/**
 * Parsing for external and internal TSCN resources.
 */
export function parseExternalResource(heading) {
    if (!heading)
        return null;
    const id = heading.attributes.id;
    const path = heading.attributes.path;
    const type = heading.attributes.type;
    return {
        id: id || '',
        path: path || '',
        type: type || '',
    };
}
export function parseInternalResource(heading, properties) {
    if (!heading)
        return null;
    const id = heading.attributes.id;
    const type = heading.attributes.type;
    return {
        id: id || '',
        type: type || '',
        data: properties,
    };
}
//# sourceMappingURL=resourceParsers.js.map